const getCurrentDirname = (path: string): string => {
  const pathParts = path.split('/');
  return pathParts[pathParts.length - 1];
};

export default getCurrentDirname;
